import StyledButton from 'components/Elements/StyledButton'
import { Container, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { LRContainer } from 'style/styledItems'
import { YourBookCardsContainer } from './style'

function YourBookCards() {
  const history = useHistory()
  const { t } = useTranslation()
  const img1 = 'https://image.anecdobio.com/your_book1.jpg'
  const img2 = 'https://image.anecdobio.com/your_book2.jpg'
  const img3 =
    'https://s3.eu-central-1.amazonaws.com/image.anecdobio.com/prod/your_book3.jpeg'
  const img4 = 'https://image.anecdobio.com/your_book4.jpg'
  const img5 = 'https://image.anecdobio.com/your_book5.jpg'

  const changeLocation = (placeToGo) => {
    history.push(placeToGo)
    window.location.reload()
  }

  return (
    <YourBookCardsContainer>
      <Container className="h-100">
        <LRContainer>
          <div className="lr-content lr-item">
            <h2>{t('book_card1_title')}</h2>
            <h4>{t('book_card1_description')}</h4>
          </div>
          <div className="lr-img lr-item">
            <Image src={img1} />
          </div>
        </LRContainer>
        <LRContainer imgPos="R">
          <div className="lr-content lr-item">
            <h2>{t('book_card2_title')}</h2>
            <h4>{t('book_card2_description')}</h4>
          </div>
          <div className="lr-img lr-item">
            <Image src={img2} />
          </div>
        </LRContainer>
        <LRContainer>
          <div className="lr-content lr-item">
            <h2>{t('book_card3_title')}</h2>
            <h4>{t('book_card3_description')}</h4>
          </div>
          <div className="lr-img lr-item">
            <Image src={img3} />
          </div>
        </LRContainer>
        <LRContainer imgPos="R">
          <div className="lr-content lr-item">
            <h2>{t('book_card4_title')}</h2>
            <h4>{t('book_card4_description')}</h4>
          </div>
          <div className="lr-img lr-item">
            <Image src={img4} />
          </div>
        </LRContainer>
        <LRContainer>
          <div className="lr-content lr-item">
            <h2>{t('book_card5_title')}</h2>
            <h4>{t('book_card5_description')}</h4>
            <StyledButton
              className="btn-blue btn-get-started"
              title={t('howitworks')}
              width={'152px'}
              onClick={() => changeLocation('/how-it-works')}
            />
          </div>
          <div className="lr-img lr-item">
            <Image src={img5} />
          </div>
        </LRContainer>
      </Container>
    </YourBookCardsContainer>
  )
}

export default YourBookCards
